import React, {createContext, useContext} from "react"
import {useTranslation} from "react-i18next"
import {ProgressIndicator} from "../../app/ProgressIndicator"

const SeasonalPassesTranslationContext = createContext(undefined)

export const SeasonalPassesTranslationProvider = ({children}) => {
    const {t, ready} = useTranslation("bpn.seasonalpasses", {useSuspense: false})

    if (ready) {
        return (
            <SeasonalPassesTranslationContext.Provider value={t}>
                {children}
            </SeasonalPassesTranslationContext.Provider>
        )
    } else {
        return <ProgressIndicator/>
    }
}

export const useSeasonalPassesTranslation = () => {
    return useContext(SeasonalPassesTranslationContext)
}